export default function Worker_fn() {
  return new Worker("/dist/8.2.5.129/" + "XhrWorker.vbworker.min.worker.js");
}
